export default __webpack_public_path__ + "static/media/dv4.e68b0e50.svg";